import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.awards.edit', []).controller('AwardsEditCtrl', AwardsEditCtrl)

/** @ngInject */
function AwardsEditCtrl(
  $state,
  $scope,
  $q,
  $stateParams,
  $timeout,
  TranslatorService,
  PostsAdminService,
  UploadService,
  AwardsService,
) {
  var vm = this
  vm.model = {}
  vm.id = parseInt($stateParams.id)
  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.pathImg = ''

  vm.awardTypes = [
    {
      id: 0,
      name: 'Draft',
    },
    {
      id: 1,
      name: 'Published',
    },
    {
      id: 2,
      name: 'Archived',
    },
  ]

  vm.segmentations = []
  vm.awardSegmentations = []

  PostsAdminService.listSegmentation().then(function (result) {
    vm.segmentations = _.filter(result.results, { arch: false })
  })

  AwardsService.listSegmentation($stateParams.id).then(function (result) {
    vm.awardSegmentations = generateType(result.results)
  })

  vm.awardTranslations = []
  function loadTranslations() {
    AwardsService.listTranslations($stateParams.id).then(function (result) {
      vm.awardTranslations = result.results
    })
  }

  loadTranslations()

  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen1 = true
    } else {
      vm.isOpen2 = true
    }
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
  //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //     if (vm.title === t && vm.description === txt) {
  //       $state.go(route)
  //       return
  //     }
  //   }

  //   TranslatorService.translateProductAllLanguage(t, txt).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               AwardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               AwardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               AwardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               AwardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               AwardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               AwardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               AwardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               AwardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           $state.go(route, { parentId: vm.parentId })
  //         })
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           AwardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           AwardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           AwardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           AwardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {
  //         $state.go(route, { parentId: vm.parentId })
  //       })
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  if (vm.id !== 0) {
    AwardsService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      vm.title = vm.model.t
      vm.description = vm.model.txt
      if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
        vm.model['ts-p'] = vm.model['ts-p']
          .toString()
          .substring(0, vm.model['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
      }
      if (vm.model['ts-x'] !== undefined && vm.model['ts-x'] !== 0) {
        vm.model['ts-x'] = vm.model['ts-x']
          .toString()
          .substring(0, vm.model['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x']))
        vm.data2 = angular.copy(vm.model['ts-x'])
      }
    })
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    if (!model.t || !model.c) {
      swal('Required title, coins', '', 'error')
      return
    }

    if (model.t.length > 44) {
      swal('Limit title 44 characters', '', 'warning')
      return
    }

    if (model.txt.length > 44) {
      swal('Limit description 44 characters', '', 'warning')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-p'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }
    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      AwardsService.update(model.id, model).then(
        function () {
          $state.go('admin.awards')
          // makeTranslation(model.t, model.txt, vm.awardTranslations, model.id, 'admin.awards')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 250)
        },
      )
    } else {
      AwardsService.save(model).then(
        function (result) {
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   vm.awardTranslations,
          //   result.results.id,
          //   'admin.awards',
          // )
          $state.go('admin.awards')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 250)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.awards')
  }

  vm.uploadImage = function (item) {
    vm.loadImg = true
    UploadService.save('coin_awards', vm.pathImg, 'img', !item.id ? 0 : item.id).then(
      function (fileName) {
        vm.loadImg = false
        item['img'] = fileName
      },
    )
  }

  vm.addSegmentation = function () {
    AwardsService.addSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        AwardsService.listSegmentation($stateParams.id).then(function (result) {
          vm.awardSegmentations = generateType(result.results)
        })
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          AwardsService.removeSegmentation($stateParams.id, id).then(function () {
            AwardsService.listSegmentation($stateParams.id).then(function (result) {
              vm.awardSegmentations = generateType(result.results)
            })
          })
        } else {
          return
        }
      },
    )
  }

  function generateType(model) {
    for (var i = 0; i < model.length; i++) {
      if (model[i].k === 1) {
        model[i].type = 'Product'
      } else if (model[i].k === 2) {
        model[i].type = 'Bundle'
      } else if (model[i].k === 3) {
        model[i].type = 'Set'
      }
    }
    return model
  }

  vm.translate = {}
  vm.pathImgTranslation = ''
  vm.loadTranslation = false
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslate').modal('show')
  }

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t || !vm.translate.txt) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      AwardsService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      AwardsService.saveTranslation($stateParams.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    AwardsService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslate').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          AwardsService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslate').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTranslation = function (item) {
    vm.loadTranslation = true
    UploadService.save('coin_awards', vm.pathImgTranslation, 'image', item.id).then(
      function (fileName) {
        vm.loadTranslation = false
        item.image = fileName
      },
    )
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })
}
